import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"
import { useDevAuth as useAuth } from "@/hooks/use-dev-auth"

import { fetchCompanyTeams, fetchTeams } from "./api"

export function useFetchTeams(options?: { enabled?: boolean; bookIdOverride?: string }) {
  const urlBookId = useBookId()
  const bookId = options?.bookIdOverride ?? urlBookId
  const getContext = useApiContext(options?.bookIdOverride)
  return useQuery({
    queryKey: ["teams", bookId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchTeams(context)
    },
    enabled: (options?.enabled ?? true) && !!bookId,
    retry: false,
  })
}

export function useFetchCompanyTeams(options?: { enabled?: boolean }) {
  const { getToken } = useAuth()
  return useQuery({
    queryKey: ["teams", "company"],
    queryFn: async () => {
      const token = await getToken()
      return fetchCompanyTeams({ token: token ?? undefined })
    },
    enabled: options?.enabled ?? true,
    retry: false,
  })
}
